export default "__VITE_ASSET__D0Qco_kL__"